import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { getTrancheFieldWithPercent } from '@/creditflowresearch/ui/components/deals/helpers';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = ({ row: tranche }: ITranchRow) => (
  tranche.yield
    ? getTrancheFieldWithPercent(tranche.yield, 3)
    : '-'
);

const YieldCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="YieldCell"
    className={ alignStyles.alignRight }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default YieldCell;
